import workspaceQuery from '../../../graphql/queries/purchases/PurchaseOrderDocumentWorkspaceQuery.graphql';
import instanceQuery from '../../../graphql/queries/purchases/PurchaseOrderDocumentQuery.graphql';
import fragment from '../../../graphql/fragments/purchases/PurchaseOrderDocumentFragment.graphql';

import generateMutation from '../../../graphql/mutations/purchases/PurchaseOrderDocumentGenerateMutation.graphql';
import generateRangeMutation from '../../../graphql/mutations/purchases/PurchaseOrderDocumentGenerateRangeMutation.graphql';
import reprintMutation from '../../../graphql/mutations/purchases/PurchaseOrderDocumentReprintMutation.graphql';

import * as printFunctions from '../../../actions/purchasing/PurchaseOrderDocumentAction';
import { purchaseDocument } from '../../../utils/mailMergeFields';
import { EntityType } from '../../../@types/entityTypes';
import { ReportType } from '../../schema/p4types';

const PurchaseOrderDocument: EntityType = {
  type: 'PurchaseOrderDocument',
  title: 'Purchase Order Document',
  formUrl: '/Purchasing/PurchaseOrderDocument/Form',
  formTitle: 'Print Purchase Order Documents',
  workspaceUrl: '/Purchasing/PurchaseOrderDocument/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  generate: generateMutation,
  generateRange: generateRangeMutation,
  reprint: reprintMutation,
  fragment,
  printFunctions: printFunctions,
  screenReference: 'PRINT_PURCHASE_ORDER_DOCUMENT',
  configuration: {
    title: 'Purchase Order',
    field: 'purchaseOrderDocumentDefault',
    reportType: ReportType.PurchaseOrderDocument,
    supplierField: 'supplierPurchaseOrderDocumentDefault',
    receiveFlag: 'receivePurchaseOrderDocument',
  },
  operations: 0,
  mergeFields: purchaseDocument,
};

export default PurchaseOrderDocument;
